export interface RequestError {
    message: string;
    status: string;
}

export enum BrandActiveUrl {
    youtube = 'youtube',
    tiktok = 'tiktok',
    facebook = 'facebook',
    instagram = 'instagram',
    twitter = 'twitter',
    twitch = 'twitch',
}
